import isNumber from 'lodash/isNumber';
import { isEnum } from '../util/general';
import { isObject } from '@mimir/primitive/type-guards/isObject';
import type { RestoreMediaRequestDto} from './restoreMediaRequestDto';
import { RestoreTier } from './restoreMediaRequestDto';

export interface RestoreMediaResponseDto {
  itemId: string;
  highRes: string;
}

export interface RestoreMediaModel extends RestoreMediaRequestDto {
  itemId: string;
}

export interface ItemRestoring {
  itemId: string;
  tier: RestoreTier;
}

export const instanceOfRestoreMediaRequestPayload = (payload: unknown): payload is RestoreMediaRequestDto => {
  return isObject(payload)
    && 'tier' in payload
    && 'retentionDays' in payload
    && isNumber(payload['retentionDays'])
    && isEnum(RestoreTier)(payload['tier']);
};

export const instanceOfRestoreMediaResponsePayload = (payload: unknown): payload is RestoreMediaResponseDto => {
  return isObject(payload)
    && 'itemId' in payload
    && 'highRes' in payload;
};
